module.exports = new __parcel__URL__("team-creation-success.2bd0a646.svg").toString();